<template>
  <el-dialog
     class="mesView"
      :visible.sync="mesView.show"
      :append-to-body="true"
       :close-on-click-modal="false"
      width="30%">
      <span slot="title" class="title">
        <span>详情</span>
      </span>
      <el-row :span="24">
        <el-col :span="8">Topic</el-col><el-col :span="16">{{content.topic}}</el-col>
      </el-row>
      <el-row>
         <el-col :span="8">时间</el-col><el-col :span="16">{{content.createTime}}</el-col>
      </el-row>
      <el-row>
         <el-col :span="8" class="flex">
          <span class="nowrap">内容</span>
          <el-select v-model="codeType" placeholder="请选择" size="small" @change="selChange" >
              <el-option
                v-for="item in codeList"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
        </el-col>
        <el-col :span="16" class="flex"><div>{{content.showCode}}</div><span class="link" @click="copy(content.showCode)">复制</span></el-col>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeView" size="small">关 闭</el-button>
      </span>
    </el-dialog>
</template>
<script>
import { logDevice } from '@/api/log'
import { copy, Base64 } from '@/utils'
export default {
  props: {
    mesView: {
      type: Object
    },
    uniMsgId: {
      type: String
    },
    productKey: {
      type: String
    },
    deviceName: {
      type: String || null
    }
  },
  data () {
    return {
      codeType: '1',
      codeList: [
        {
          value: '1',
          label: 'Text(UTF-8)'
        },
        // {
        //   value: '2',
        //   label: 'Hex'
        // },
        // {
        //   value: '3',
        //   label: 'Text(ISO-8859-1)'
        // },
        {
          value: '4',
          label: 'Base64 编码'
        }
      ],
      content: {
        base64: '',
        textUtf8: '',
        hex: '',
        textIso: '',
        showCode: '',
        createTime: '',
        topic: ''
      }
    }
  },
  methods: {
    closeView () {
      this.$emit('close-view')
    },
    copy (val) {
      // 设备添加完毕后复制证书
      copy(val, () => {
        this.$message({
          type: 'success',
          message: '复制成功'
        })
      })
    },
    selChange (val) {
      val === '1'
        ? this.content.showCode = this.content.textUtf8
        : val === '2'
          ? this.content.showCode = this.content.hex
          : val === '3'
            ? this.content.showCode = this.content.textIso
            : val === '4'
              ? this.content.showCode = this.content.base64
              : ''
    },
    getLogDevice () {
      // this.$emit('close-view')
      const params = {
        msgId: this.uniMsgId,
        productKey: this.productKey,
        deviceName: this.deviceName
      }
      logDevice(params).then(res => {
        res = res.data
        // 获取到数据，再打开弹窗
        // this.$emit('open-view')
        this.codeType = '1'
        console.log('消息详情：', res)
        // 用于保存原始的base64编码
        this.content.base64 = res.data.dataMsg
        this.content.textUtf8 = Base64.decode(res.data.dataMsg)
        // this.content.textUtf8 = // window.decodeURI(es.data.dataMsg)
        // 默认显示utf8
        this.content.showCode = this.content.textUtf8
        this.content.createTime = res.data.createTime
        this.content.topic = res.data.topic
      })
    }
  },
  created () {
    console.log('mesView:', this.mesView)
    console.log('uniMsgId:', this.uniMsgId)
  },
  watch: {
    uniMsgId () {
      // uniMsgId有变化的时候再发起请求
      console.log('uniMsgId变化了:', this.uniMsgId)
      this.getLogDevice()
    },
    'mesView.show' () {
      console.log('弹窗标记变化了')
    }
  }
}
</script>
<style lang="less" scope>
.mesView{
  .title{
    font-size: 18px;
  }
  .link{
      color: #0070cc;
      cursor: pointer;
       white-space: nowrap;
  }
  .flex{
    display: flex;
  }
  .nowrap{
      white-space: nowrap;
      display: flex;
      align-items: center;
  }
  .el-col{
      padding: 10px;
      max-height: 100px;
      overflow: hidden;
      &:nth-child(even){
        background-color: white;
      }
    }
    .el-row{
       background-color:#E4E7ED
    }
  .el-input__inner{
    //设置为透明，去掉背景色
    background-color: rgba(0,0,0,0);
    border: none;
  }
}
</style>
